"use client";
import {
  IDefaultPackage,
  IPackages,
  TServiceNavigationItem,
} from "@/interfaces";
import { CustomButton } from "@/components/ui";
import { BdAltArrowRight } from "solar-icon-react/bd";
import InsufficientBalanceModal from "@/components/Payment/insufficientBalanceModal";
import SufficientBalanceModal from "@/components/Payment/sufficientBalanceModal";

interface Props {
  selectedService?: TServiceNavigationItem | any;
  paymentSubmission: (data: any) => void;
  handleBackBtn?: () => void;
  submissionError: Error | null;
  submissionLoading: boolean;
  showManualError?: string | null;
  payBtnId?: string;
  isTimerActive?: boolean;
  timerEndTime?: number | null;
  onTimerComplete?: () => void;
  selectedPackage?: IDefaultPackage | IPackages;
  packages?: IPackages[];
  globalUser?: IPackages[];
  onClose: () => void;
  walletBalanceData: any;
  inquiryData: any;
  error?: Error | null;
  isLoading: boolean;
  isUseWallet: boolean;
  setIsUseWallet: (isUseWallet: boolean) => void;
  serviceManualCost?: number;
  btnTitle?: string;
  paymentNotice?: string;
}

export default function PaymentModalStepTwo({
  onClose,
  selectedService,
  submissionError,
  showManualError = null,
  submissionLoading = false,
  payBtnId,
  handleBackBtn,
  isTimerActive,
  onTimerComplete,
  timerEndTime,
  selectedPackage,
  globalUser,
  paymentSubmission,
  walletBalanceData,
  inquiryData,
  error,
  isLoading,
  setIsUseWallet,
  isUseWallet,
  serviceManualCost,
  btnTitle,
  paymentNotice,
}: Props) {
  const walletBalance = Number(walletBalanceData?.data?.balance || 0);
  const serviceCost = Number(
    serviceManualCost || inquiryData?.data?.price_user || 0,
  );
  const isSingleInquiry = selectedPackage?.id === "p0";
  const isWalletBalanceInsufficient =
    isSingleInquiry && (walletBalance === 0 || walletBalance < serviceCost);

  return (
    <>
      {handleBackBtn &&
        walletBalanceData?.data?.payment_type !== "postpaid" && (
          <div className="flex items-center justify-start! pt-3">
            <CustomButton
              variant="text"
              icon={<BdAltArrowRight size={20} />}
              className="mx-0! w-fit! max-w-[280px] px-3! text-sm!"
              onClick={handleBackBtn}
            >
              بازگشت به مرحله قبل
            </CustomButton>
          </div>
        )}
      {paymentNotice ? (
        <div className="mx-4 mt-4 rounded-xl border border-yellow-200 bg-yellow-50 px-4 py-3 text-sm leading-7 text-yellow-800">
          {paymentNotice}
        </div>
      ) : null}
      {isWalletBalanceInsufficient &&
      walletBalanceData?.data?.payment_type !== "postpaid" ? (
        <InsufficientBalanceModal
          incrementBtnId={payBtnId}
          onClose={onClose}
          onSubmit={(data: any) => paymentSubmission(data)}
          walletBalance={walletBalanceData?.data?.balance}
          inquiryPrice={serviceManualCost || inquiryData?.data?.price_user}
          error={error}
          isLoading={isLoading}
          selectedPackage={selectedPackage}
          hasPackage={
            selectedPackage?.id !== "p0" && Boolean(globalUser?.length)
          }
          showManualError={showManualError}
        />
      ) : (
        <SufficientBalanceModal
          payBtnId={payBtnId}
          onClose={onClose}
          onSubmit={(data: any) => paymentSubmission(data)}
          paymentType={walletBalanceData?.data?.payment_type}
          error={submissionError}
          serviceType={selectedService}
          walletBalance={walletBalanceData?.data?.balance}
          inquiryPrice={serviceManualCost || inquiryData?.data?.price_user}
          isLoading={submissionLoading}
          showManualError={showManualError}
          selectedPackage={selectedPackage}
          useWallet={isUseWallet}
          walletHandler={setIsUseWallet}
          hasPackage={
            selectedPackage?.id !== "p0" && Boolean(globalUser?.length)
          }
          isTimerActive={isTimerActive}
          timerEndTime={timerEndTime}
          onTimerComplete={onTimerComplete}
          btnTitle={btnTitle}
        />
      )}
    </>
  );
}
